(() => {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.ce_desktop_navigation .level_1 > li.parent').forEach((level1Item) => {
      const subnav = level1Item.querySelector('ul.level_2');
      if (subnav) {
        level1Item.setAttribute('aria-expanded', 'false');

        level1Item.addEventListener('mouseenter', () => {
          level1Item.classList.add('hover');
          level1Item.setAttribute('aria-expanded', 'true');
        });

        level1Item.addEventListener('mouseleave', () => {
          level1Item.setAttribute('aria-expanded', 'false');
          level1Item.classList.remove('hover');
        });

        level1Item.querySelectorAll(':scope > a, :scope > span').forEach((childElement) => {
          childElement.setAttribute('role', 'button');
          childElement.addEventListener('click', (e) => {
            e.stopPropagation();
            if (level1Item.classList.contains('hover')) {
              level1Item.classList.remove('hover');
              level1Item.setAttribute('aria-expanded', 'false');
            } else {
              level1Item.classList.add('hover');
              level1Item.setAttribute('aria-expanded', 'true');
            }
          });

          childElement.addEventListener('keydown', (e) => {
            if (e.key !== 'Enter') {
                return
            }

            e.preventDefault();

            if (level1Item.classList.contains('hover')) {
              level1Item.classList.remove('hover');
              level1Item.setAttribute('aria-expanded', 'false');
            } else {
              level1Item.classList.add('hover');
              level1Item.setAttribute('aria-expanded', 'true');
            }
          });
        });
      }
    });
  });

  document.querySelectorAll('.ce_desktop_navigation .level_2 a, .ce_desktop_navigation .level_2 span[tabindex]').forEach((childElement) => {
    childElement.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') {
            return
        }

        e.preventDefault();

        const parentLevel1 = childElement.closest('ul.level_1 > .subnav');

        // Revert active state
        parentLevel1.classList.remove('hover');
        parentLevel1.setAttribute('aria-expanded', 'false');

        // Focus next navigation item
        if (parentLevel1.nextElementSibling) {
            parentLevel1.nextElementSibling.querySelector(':scope > a, :scope > span').focus();

            return
        }

        // Focus first maincontent item
        document.querySelector('#maincontent').querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])').focus()
    });
  });
})();